module.exports = __webpack_public_path__ + "static/montserrat-regular-webfont-f1d8490adab3c0d08d39b7efa60c692e.woff2";